// ============================================
// OUTLET MASTER DATA
// Real outlets from indianstreetfood.com
// ============================================

import { ownershipTypes } from './franchise';

export const outlets = [
  // ==========================================
  // NORWAY - Corporate Owned (Primary Market)
  // ==========================================
  {
    id: 'no-sorengkaia',
    code: 'NO-OSL-01',
    name: 'Sørengkaia',
    brandId: 'isf',
    franchiseeId: 'isf-corporate',
    ownershipType: ownershipTypes.CORPORATE,
    
    // Location
    address: {
      street: 'Sørengkaia 7',
      postalCode: '0194',
      city: 'Oslo',
      region: 'Oslo',
      country: 'NO',
      coordinates: { lat: 59.9050, lng: 10.7522 },
    },
    
    // Operations
    timezone: 'Europe/Oslo',
    currency: 'NOK',
    locale: 'nb-NO',
    
    // Contact
    phone: '+47 21 38 56 00',
    email: 'sorengkaia@isfco.no',
    
    // Capacity
    capacity: {
      indoor: 80,
      outdoor: 40,
      bar: 15,
      total: 135,
    },
    tableCount: 25,
    
    // Operating hours
    operatingHours: {
      monday: { open: '11:00', close: '23:00' },
      tuesday: { open: '11:00', close: '23:00' },
      wednesday: { open: '11:00', close: '23:00' },
      thursday: { open: '11:00', close: '23:00' },
      friday: { open: '11:00', close: '00:00' },
      saturday: { open: '12:00', close: '00:00' },
      sunday: { open: '12:00', close: '22:00' },
    },
    
    // Services
    services: {
      dineIn: true,
      takeaway: true,
      delivery: true,
      catering: true,
      reservations: true,
      privateEvents: true,
    },
    
    // Integrations
    integrations: {
      pos: 'internal',
      delivery: ['wolt', 'foodora'],
      reservations: 'internal',
      accounting: 'tripletex',
      hr: 'planday',
    },
    
    // Status
    status: 'active',
    openedDate: '2018-05-15',
    lastRenovation: '2022-08-01',
    
    // Performance metrics (for dashboard)
    metrics: {
      avgDailySales: 85000,
      avgTicket: 520,
      avgCovers: 165,
      staffCount: 24,
    },
  },
  {
    id: 'no-frogner',
    code: 'NO-OSL-02',
    name: 'Frogner',
    brandId: 'isf',
    franchiseeId: 'isf-corporate',
    ownershipType: ownershipTypes.CORPORATE,
    
    address: {
      street: 'Frognerveien 2',
      postalCode: '0257',
      city: 'Oslo',
      region: 'Oslo',
      country: 'NO',
      coordinates: { lat: 59.9214, lng: 10.7086 },
    },
    
    timezone: 'Europe/Oslo',
    currency: 'NOK',
    locale: 'nb-NO',
    
    phone: '+47 21 38 56 01',
    email: 'frogner@isfco.no',
    
    capacity: {
      indoor: 65,
      outdoor: 25,
      bar: 10,
      total: 100,
    },
    tableCount: 20,
    
    operatingHours: {
      monday: { open: '11:00', close: '22:00' },
      tuesday: { open: '11:00', close: '22:00' },
      wednesday: { open: '11:00', close: '22:00' },
      thursday: { open: '11:00', close: '22:00' },
      friday: { open: '11:00', close: '23:00' },
      saturday: { open: '12:00', close: '23:00' },
      sunday: { open: '12:00', close: '21:00' },
    },
    
    services: {
      dineIn: true,
      takeaway: true,
      delivery: true,
      catering: false,
      reservations: true,
      privateEvents: false,
    },
    
    integrations: {
      pos: 'internal',
      delivery: ['wolt', 'foodora'],
      reservations: 'internal',
      accounting: 'tripletex',
      hr: 'planday',
    },
    
    status: 'active',
    openedDate: '2019-09-01',
    lastRenovation: null,
    
    metrics: {
      avgDailySales: 62000,
      avgTicket: 485,
      avgCovers: 128,
      staffCount: 18,
    },
  },

  // ==========================================
  // SWEDEN - Franchise Operated
  // ==========================================
  {
    id: 'se-hammarby',
    code: 'SE-STO-01',
    name: 'Hammarby Sjöstad',
    brandId: 'isf',
    franchiseeId: 'isf-stockholm-ab',
    ownershipType: ownershipTypes.FRANCHISE,
    
    address: {
      street: 'Jan Inghes Torg 22',
      postalCode: '120 32',
      city: 'Stockholm',
      region: 'Stockholm',
      country: 'SE',
      coordinates: { lat: 59.3043, lng: 18.1044 },
    },
    
    timezone: 'Europe/Stockholm',
    currency: 'SEK',
    locale: 'sv-SE',
    
    phone: '+46 8 641 00 01',
    email: 'hammarby@isfstockholm.se',
    
    capacity: {
      indoor: 70,
      outdoor: 30,
      bar: 12,
      total: 112,
    },
    tableCount: 22,
    
    operatingHours: {
      monday: { open: '11:00', close: '22:00' },
      tuesday: { open: '11:00', close: '22:00' },
      wednesday: { open: '11:00', close: '22:00' },
      thursday: { open: '11:00', close: '22:00' },
      friday: { open: '11:00', close: '23:00' },
      saturday: { open: '12:00', close: '23:00' },
      sunday: { open: '12:00', close: '21:00' },
    },
    
    services: {
      dineIn: true,
      takeaway: true,
      delivery: true,
      catering: true,
      reservations: true,
      privateEvents: true,
    },
    
    integrations: {
      pos: 'internal',
      delivery: ['foodora', 'uber-eats'],
      reservations: 'internal',
      accounting: 'fortnox',
      hr: 'planday',
    },
    
    status: 'active',
    openedDate: '2018-03-20',
    lastRenovation: '2023-01-15',
    
    metrics: {
      avgDailySales: 78000,
      avgTicket: 495,
      avgCovers: 158,
      staffCount: 22,
    },
  },
  {
    id: 'se-karlbergsvagen',
    code: 'SE-STO-02',
    name: 'Karlbergsvägen',
    brandId: 'isf',
    franchiseeId: 'isf-stockholm-ab',
    ownershipType: ownershipTypes.FRANCHISE,
    
    address: {
      street: 'Karlsbergsvägen 43',
      postalCode: '113 31',
      city: 'Stockholm',
      region: 'Stockholm',
      country: 'SE',
      coordinates: { lat: 59.3456, lng: 18.0321 },
    },
    
    timezone: 'Europe/Stockholm',
    currency: 'SEK',
    locale: 'sv-SE',
    
    phone: '+46 8 641 00 02',
    email: 'karlbergsvagen@isfstockholm.se',
    
    capacity: {
      indoor: 55,
      outdoor: 20,
      bar: 8,
      total: 83,
    },
    tableCount: 18,
    
    operatingHours: {
      monday: { open: '11:00', close: '22:00' },
      tuesday: { open: '11:00', close: '22:00' },
      wednesday: { open: '11:00', close: '22:00' },
      thursday: { open: '11:00', close: '22:00' },
      friday: { open: '11:00', close: '23:00' },
      saturday: { open: '12:00', close: '23:00' },
      sunday: { open: '12:00', close: '21:00' },
    },
    
    services: {
      dineIn: true,
      takeaway: true,
      delivery: true,
      catering: false,
      reservations: true,
      privateEvents: false,
    },
    
    status: 'active',
    openedDate: '2019-02-14',
    
    metrics: {
      avgDailySales: 58000,
      avgTicket: 465,
      avgCovers: 125,
      staffCount: 16,
    },
  },
  {
    id: 'se-st-eriksgatan',
    code: 'SE-STO-03',
    name: 'St Eriksgatan',
    brandId: 'isf',
    franchiseeId: 'isf-stockholm-ab',
    ownershipType: ownershipTypes.FRANCHISE,
    
    address: {
      street: 'St Eriksgatan 116',
      postalCode: '113 32',
      city: 'Stockholm',
      region: 'Stockholm',
      country: 'SE',
      coordinates: { lat: 59.3401, lng: 18.0298 },
    },
    
    timezone: 'Europe/Stockholm',
    currency: 'SEK',
    locale: 'sv-SE',
    
    phone: '+46 8 641 00 03',
    email: 'steriksgatan@isfstockholm.se',
    
    capacity: {
      indoor: 60,
      outdoor: 15,
      bar: 10,
      total: 85,
    },
    tableCount: 17,
    
    operatingHours: {
      monday: { open: '11:00', close: '22:00' },
      tuesday: { open: '11:00', close: '22:00' },
      wednesday: { open: '11:00', close: '22:00' },
      thursday: { open: '11:00', close: '22:00' },
      friday: { open: '11:00', close: '23:00' },
      saturday: { open: '12:00', close: '23:00' },
      sunday: { open: '12:00', close: '21:00' },
    },
    
    services: {
      dineIn: true,
      takeaway: true,
      delivery: true,
      catering: false,
      reservations: true,
      privateEvents: false,
    },
    
    status: 'active',
    openedDate: '2019-08-01',
    
    metrics: {
      avgDailySales: 55000,
      avgTicket: 480,
      avgCovers: 115,
      staffCount: 15,
    },
  },
  {
    id: 'se-gotgatan',
    code: 'SE-STO-04',
    name: 'Götgatan (Ringen)',
    brandId: 'isf',
    franchiseeId: 'isf-stockholm-ab',
    ownershipType: ownershipTypes.FRANCHISE,
    
    address: {
      street: 'Götgatan 100 (Ringen Centrum)',
      postalCode: '118 62',
      city: 'Stockholm',
      region: 'Stockholm',
      country: 'SE',
      coordinates: { lat: 59.3087, lng: 18.0749 },
    },
    
    timezone: 'Europe/Stockholm',
    currency: 'SEK',
    locale: 'sv-SE',
    
    phone: '+46 8 641 00 04',
    email: 'gotgatan@isfstockholm.se',
    
    capacity: {
      indoor: 45,
      outdoor: 0,
      bar: 6,
      total: 51,
    },
    tableCount: 14,
    
    operatingHours: {
      monday: { open: '10:00', close: '21:00' },
      tuesday: { open: '10:00', close: '21:00' },
      wednesday: { open: '10:00', close: '21:00' },
      thursday: { open: '10:00', close: '21:00' },
      friday: { open: '10:00', close: '21:00' },
      saturday: { open: '10:00', close: '21:00' },
      sunday: { open: '11:00', close: '20:00' },
    },
    
    services: {
      dineIn: true,
      takeaway: true,
      delivery: false,
      catering: false,
      reservations: false, // Mall location
      privateEvents: false,
    },
    
    status: 'active',
    openedDate: '2020-03-01',
    
    metrics: {
      avgDailySales: 48000,
      avgTicket: 285,
      avgCovers: 168,
      staffCount: 12,
    },
  },
  {
    id: 'se-drottninggatan',
    code: 'SE-STO-05',
    name: 'Drottninggatan',
    brandId: 'isf',
    franchiseeId: 'isf-stockholm-ab',
    ownershipType: ownershipTypes.FRANCHISE,
    
    address: {
      street: 'Drottninggatan 73 B',
      postalCode: '111 36',
      city: 'Stockholm',
      region: 'Stockholm',
      country: 'SE',
      coordinates: { lat: 59.3369, lng: 18.0587 },
    },
    
    timezone: 'Europe/Stockholm',
    currency: 'SEK',
    locale: 'sv-SE',
    
    phone: '+46 8 641 00 05',
    email: 'drottninggatan@isfstockholm.se',
    
    capacity: {
      indoor: 50,
      outdoor: 10,
      bar: 8,
      total: 68,
    },
    tableCount: 16,
    
    operatingHours: {
      monday: { open: '11:00', close: '22:00' },
      tuesday: { open: '11:00', close: '22:00' },
      wednesday: { open: '11:00', close: '22:00' },
      thursday: { open: '11:00', close: '22:00' },
      friday: { open: '11:00', close: '23:00' },
      saturday: { open: '11:00', close: '23:00' },
      sunday: { open: '12:00', close: '21:00' },
    },
    
    services: {
      dineIn: true,
      takeaway: true,
      delivery: true,
      catering: false,
      reservations: true,
      privateEvents: false,
    },
    
    status: 'active',
    openedDate: '2021-06-15',
    
    metrics: {
      avgDailySales: 52000,
      avgTicket: 425,
      avgCovers: 122,
      staffCount: 14,
    },
  },
  {
    id: 'se-solna',
    code: 'SE-SOL-01',
    name: 'Solna',
    brandId: 'isf',
    franchiseeId: 'isf-solna-ab',
    ownershipType: ownershipTypes.FRANCHISE,
    
    address: {
      street: 'Trubadurvägen 12',
      postalCode: '171 67',
      city: 'Solna',
      region: 'Stockholm',
      country: 'SE',
      coordinates: { lat: 59.3692, lng: 18.0046 },
    },
    
    timezone: 'Europe/Stockholm',
    currency: 'SEK',
    locale: 'sv-SE',
    
    phone: '+46 8 641 00 06',
    email: 'solna@isfsolna.se',
    
    capacity: {
      indoor: 75,
      outdoor: 35,
      bar: 12,
      total: 122,
    },
    tableCount: 24,
    
    operatingHours: {
      monday: { open: '11:00', close: '22:00' },
      tuesday: { open: '11:00', close: '22:00' },
      wednesday: { open: '11:00', close: '22:00' },
      thursday: { open: '11:00', close: '22:00' },
      friday: { open: '11:00', close: '23:00' },
      saturday: { open: '12:00', close: '23:00' },
      sunday: { open: '12:00', close: '21:00' },
    },
    
    services: {
      dineIn: true,
      takeaway: true,
      delivery: true,
      catering: true,
      reservations: true,
      privateEvents: true,
    },
    
    status: 'active',
    openedDate: '2020-06-10',
    
    metrics: {
      avgDailySales: 68000,
      avgTicket: 510,
      avgCovers: 133,
      staffCount: 20,
    },
  },
];

// ============================================
// HELPER FUNCTIONS
// ============================================

export const getOutletById = (id) => outlets.find(o => o.id === id);
export const getOutletByCode = (code) => outlets.find(o => o.code === code);
export const getOutletsByCountry = (country) => outlets.filter(o => o.address.country === country);
export const getOutletsByFranchisee = (franchiseeId) => outlets.filter(o => o.franchiseeId === franchiseeId);
export const getOutletsByBrand = (brandId) => outlets.filter(o => o.brandId === brandId);
export const getActiveOutlets = () => outlets.filter(o => o.status === 'active');
export const getCorporateOutlets = () => outlets.filter(o => o.ownershipType === 'corporate');
export const getFranchiseOutlets = () => outlets.filter(o => o.ownershipType === 'franchise');

// Get outlet summary for dropdowns
export const getOutletOptions = () => outlets.map(o => ({
  id: o.id,
  code: o.code,
  name: o.name,
  city: o.address.city,
  country: o.address.country,
  currency: o.currency,
  ownershipType: o.ownershipType,
}));

// Group outlets by country
export const getOutletsGroupedByCountry = () => {
  return outlets.reduce((acc, outlet) => {
    const country = outlet.address.country;
    if (!acc[country]) acc[country] = [];
    acc[country].push(outlet);
    return acc;
  }, {});
};
